
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    financecontractInvoiceDetail
  } from "@/api/finance"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0

    private mounted () {
      this.gettablelist()
    }



    
    private tocopy(e,row){
      let text = row.ProductNames
      
      handleClipboard(text,e)
    }
    private exportFile(){
      let url = location.origin + '/pc/finance/contractInvoiceDetailExport'
      url += '?ContractType=2'
      url += '&InvoiceState=' + this.$route.query.InvoiceState
      url += '&BillNo=' + this.keywords
      url += '&IdList=' + this.$route.query.Ids
      url += '&ProviderId=' + this.$route.query.Id
      window.open(url)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private clearSearch(){
      this.pageNo = 1
      this.keywords = ''
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true  
        let res = await financecontractInvoiceDetail({
          ContractType:2,
          InvoiceState:this.$route.query.InvoiceState,
          ProviderId:this.$route.query.Id,
          BillNo:this.keywords,
          IdList:this.$route.query.Ids,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
